const axios = require('axios');

class Api extends Error {
  constructor(message) {
    super(`ApiError: ${message}`);
  }
}

class Domain extends Error {
  constructor(message) {
    super(message);
  }
}

class ErrorMessage {
  message(error, msg) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      const messageResponse = data?.message;
      const codeResponse = data?.code;

      if (codeResponse === 'TOTVS_INTEGRATION_FAILED') {
        return new Domain('Nao foi possivel integrar o pedido no sistema principal (TOTVS). O pedido nao foi salvo localmente. Tente novamente em instantes.');
      }

      if (status >= 400 && status < 500) {
        return new Domain(messageResponse || msg);
      }

      if (status >= 500) {
        return new Api(messageResponse || msg);
      }
    }

    return new Error(msg);
  }

  messageCustom(error, msg) {
    if (axios.isAxiosError(error) && error.response) {
      const titleResponse = error.response.data?.title;
      const messageResponse = error.response.data?.message;
      return {
        title: titleResponse || 'Erro na operacao',
        message: messageResponse || msg,
      };
    }

    return {
      title: 'Erro não identificado',
      message: msg,
    };
  }
}

module.exports = { Api, Domain, ErrorMessage };
